import { useState, useEffect } from "react";
import { HiEnvelope } from "react-icons/hi2";
import { FaXTwitter } from "react-icons/fa6";

import { getUser } from "../utilities/users-service";
import Main from "../components/Main/Main";
import NavBar from "../components/NavBar/NavBar";

export default function App() {
  const [user, setUser] = useState(getUser());

  // Re-check the token periodically so admin controls disappear when it
  // expires while the page stays open (getUser() returns null after expiry)
  useEffect(() => {
    const id = setInterval(() => {
      setUser((current) => {
        const fresh = getUser();
        return fresh?._id === current?._id ? current : fresh;
      });
    }, 60 * 1000);
    return () => clearInterval(id);
  }, []);

  return (
    // Flex column + grow on <main> pins the footer to the bottom of short
    // pages without hardcoding nav/footer heights
    <div className="text-left font-serif bg-paper text-ink min-h-screen flex flex-col">
      <NavBar user={user} setUser={setUser} />
      <Main user={user} setUser={setUser} />
      {/* Same font and colour as the nav links, two sizes down, left edge on
          the site grid. The footer follows the content (no sticky-footer
          stretch) so the gap stays fixed: 4px scroll sentinel + 24.5px pt
          + ~4.5px of line box above the ink = 33px from the last tile's
          bottom edge to the copyright's ink — the same whitespace as between
          the hero divider and the filter pills */}
      <footer className="pt-[24.5px] pb-6">
        {/* One spaced-out row at all sizes; wraps only when it runs out of room */}
        <div className="max-w-[1287px] mx-auto px-6 flex flex-wrap items-center justify-between gap-x-4 gap-y-1.5 sm:items-baseline text-[13px] text-ink/80">
          <span>&copy; 2026 The Japanese Stamp Archive</span>
          {/* Icons on mobile, text links (with bullet separator) from sm up */}
          <span className="flex flex-wrap items-center gap-x-5 gap-y-1.5 sm:items-baseline sm:gap-x-2">
            <a
              href="mailto:contact@japanstamp.ca"
              aria-label="Share feedback"
              className="no-underline text-ink/80 hover:text-seal transition-colors"
            >
              <HiEnvelope className="w-[18px] h-[18px] sm:hidden" aria-hidden="true" />
              <span className="hidden sm:inline">Share feedback</span>
            </a>
            <span aria-hidden="true" className="hidden sm:inline">&bull;</span>
            <a
              href="https://x.com/japanstampca"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on X"
              className="no-underline text-ink/80 hover:text-seal transition-colors"
            >
              <FaXTwitter className="w-4 h-4 sm:hidden" aria-hidden="true" />
              <span className="hidden sm:inline">Follow us on X</span>
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
}
